// extracted by mini-css-extract-plugin
module.exports = {"preloader":"OslaLoader_preloader__1FT8l","spawn":"OslaLoader_spawn__2-URT"};